import { render, staticRenderFns } from "./timeheader.vue?vue&type=template&id=918ac31a&scoped=true&"
import script from "./timeheader.vue?vue&type=script&lang=js&"
export * from "./timeheader.vue?vue&type=script&lang=js&"
import style0 from "./timeheader.vue?vue&type=style&index=0&id=918ac31a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918ac31a",
  null
  
)

export default component.exports